module.exports = __webpack_public_path__ + "img/4_3.748446ba.png";